module.exports = __webpack_public_path__ + "media/components/live/rdc/images/how-it-works-1-5217a2904fbfb88103c3979dd72d2869.png";